module.exports = __webpack_public_path__ + "0c48cf5cb54d980a4b228307221dad97.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/media/6/6.jpg
// module id = 583
// module chunks = 0